export default class AuthenticationError extends Error {
  constructor() {
    super(
      'There was a problem authenticating.  Please check ther username and/or password.',
    );
  }
}
